import axios from 'axios';
import {
	ChangePhonePayload,
	ChangePhoneResponse,
	ContactPersonRequestPayload,
	ContactPersonResponse,
	VerifyPhonePayload,
} from '../models/contactProfile';
import { JsonResponse } from 'core/models/response';

// otp TTL
let otpTTL = 120;
let isRedirectedFromContactPage = false;

export const getOtpTTL = () => otpTTL;
export const setOtpTTL = (value: number) => {
	otpTTL = value;
	isRedirectedFromContactPage = true;
};

export const getIsRedirectedFromContactPage = () => isRedirectedFromContactPage;

export const submitContactPersonalInfo = async (data: ContactPersonRequestPayload) => {
	try {
		const response = await axios.post<JsonResponse<ContactPersonResponse>>('register/contact-person', data);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const verifyPhone = async (data: VerifyPhonePayload) => {
	try {
		const response = await axios.post<JsonResponse<ContactPersonResponse>>('register/verify-phone', data);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const resendOtp = async (recaptcha_token: string) => {
	try {
		const response = await axios.post('register/resend-otp', { recaptcha_token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const changePhone = async (data: ChangePhonePayload) => {
	try {
		const response = await axios.put<JsonResponse<ChangePhoneResponse>>('register/change-phone', data);
		return response.data;
	} catch (error) {
		throw error;
	}
};
